module.exports = __webpack_public_path__ + "media/images/alt_star-b9e2b90f.gif";